import { useState, useEffect, useRef } from "react";
// import emailjs from "@emailjs/browser";
import "./GetStartedForm.css";
// import PublishingOptions from "./PublishingOptions";
import PublishingComparison from "./PublishingComparison";

import LabelledCheckbox from "../../Components/LabelledCheckbox/LabelledCheckbox";

import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { fetchCaptcha } from "../../Api/Backend/Captcha";
import { submitConsultation } from "../../Api/Backend/Consultation";

const GetStartedForm = () => {
  const navigate = useNavigate();
  const { isLoggedIn, user, auth } = useAuth();

  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const MAX_FILE_SIZE_MB = 25; // file size threshold
  const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
  const MAX_FILES = 5;

  const publicationTypes = ["자비 출판", "반기획 출판", "기획 출판", "아마존 킨들 출판"];
  const [formData, setFormData] = useState({
    name: "",
    email: isLoggedIn && user?.email ? user.email : "",
    phoneNumber: "",
    details: "",
    publicationType: publicationTypes[0],
    agreement: false,
  });

  const [isSending, setIsSending] = useState(false);

  const [captchaId, setCaptchaId] = useState("");
  const [captchaImg, setCaptchaImg] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  const loadCaptcha = async () => {
    const data = await fetchCaptcha(); // { captchaId, image }    
    setCaptchaId(data.captchaId);
    setCaptchaImg(data.image);
    setCaptchaInput("");

  };

  useEffect(() => {
    fetchCaptcha({
      auth, // auth가 없으면 빼도 됨 (permitAll이면)
      onSuccess: (data) => {
        setCaptchaId(data.captchaId);
        setCaptchaImg(data.image);
        setCaptchaInput("");
      },
      onError: (e) => console.error(e),
    });
  }, [auth]);

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);

    if (newFiles.some(f => f.size > MAX_FILE_SIZE)) {
      alert("파일 크기는 25MB를 초과할 수 없습니다.");
      return;
    }
    if (files.length + newFiles.length > MAX_FILES) {
      alert(`최대 ${MAX_FILES}개 파일만 업로드할 수 있습니다.`);
      return;
    }

    const duplicates = newFiles.filter(nf => files.some(ef => ef.name === nf.name && ef.size === nf.size));
    if (duplicates.length > 0) {
      alert("중복된 파일은 업로드할 수 없습니다.");
      return;
    }

    setFiles(prev => [...prev, ...newFiles]);
    e.target.value = null;
  };

  const handleRemoveFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // const handleOptionSelect = (optionName) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     publicationType: optionName,
  //   }));
  // };

  const handleEstimateClick = () => {
    // if (!isLoggedIn) {
    //   const confirmed = window.confirm("견적서 페이지는 로그인이 필요합니다.\n\n로그인 하시겠습니까?");
    //   if (confirmed) {
    //     navigate("/login");
    //   }
    // } else {
    //   const message = `현재 화면을 이동하면 작성중인 메세지는 삭제됩니다. 신청 완료후 이동하시기 바랍니다.\n\n이동 하시겠습니까?`;
    //   const confirmed = window.confirm(message);
    //   if (confirmed) {
    //     navigate("/quote");
    //   }
    // }
    const message = `현재 화면을 이동하면 작성중인 메세지는 삭제됩니다. 신청 완료후 이동하시기 바랍니다.\n\n이동 하시겠습니까?`;
    const confirmed = window.confirm(message);
    if (confirmed) {
      navigate("/quote");
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (files.length === 0) {
      alert("원고 파일, 목차, 기획안, 샘플 원고 중 1개 이상을 첨부해 주세요.");
      return;
    }

    if (!formData.agreement) {
      alert("개인정보 수집 및 이용에 동의해주세요.");
      return;
    }

    setIsSending(true);

    try {
      const formPayload = new FormData();
      formPayload.append("payload", new Blob([JSON.stringify({
        ...formData,
        captchaId,
        captchaValue: captchaInput,
      })], { type: "application/json" }));

      files.forEach(file => formPayload.append("files", file));

      await submitConsultation({
        payload: {
          ...formData,
          captchaId,
          captchaValue: captchaInput,
        },
        files,
      });

      // await submitConsultation({
      //   payload: {
      //     ...formData,
      //     captchaId,
      //     captchaValue: captchaInput, // ✅ 서버가 여기서 검증
      //   },
      // });

      alert("상담 신청이 성공적으로 전송되었습니다. 감사합니다!");
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        details: "",
        publicationType: "자비 출판",
        agreement: false,
      });
      setFiles([]);

      await loadCaptcha(); // 새 캡챠
    } catch (err) {
      // 서버가 내려준 message가 있으면 보여주기(지금 Utils에서 message 만들어주고 있음)
      alert(err?.message || "전송에 실패했습니다. 캡챠를 확인하고 다시 시도해주세요.");
      await loadCaptcha(); // 실패하면 무조건 새 캡챠
    } finally {
      setIsSending(false);
    }

    // emailjs
    //   .send(
    //     process.env.REACT_APP_EMAILJS_SERVICE_ID,
    //     process.env.REACT_APP_EMAILJS_CONSULTATION_TEMPLATE_ID,
    //     formData,
    //     process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    //   )
    //   .then((result) => {
    //     console.log(result.text);
    //     alert("상담 신청이 성공적으로 전송되었습니다. 감사합니다!");
    //     setFormData({
    //       name: "",
    //       email: "",
    //       phoneNumber: "",
    //       details: "",
    //       publicationType: "자비 출판",
    //       agreement: false,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error.text);
    //     alert("메일 전송에 실패했습니다. 잠시 후 다시 시도해주세요.");
    //   })
    //   .finally(() => {
    //     setIsSending(false);
    //   });
  };

  return (
    <section className="get-started-form-container">
      <div className="form-header">
        <div>빠르고 정확한 출판 준비, 지금 시작해보세요!</div>
        <div>지금 상담을 신청하시면, 출판 전문가가 1:1로 도와드립니다.</div>
      </div>

      <form onSubmit={handleSubmit} className="contact-form">
        {/* Name */}
        <div className="form-group">
          <label htmlFor="name">이름</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="이름을 입력해 주세요"
            required
          />
        </div>
        {/* Email */}
        <div className="form-group">
          <label htmlFor="email">이메일</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="이메일 주소를 입력해 주세요"
            required
          />
        </div>
        {/* phoneNumber Number */}
        <div className="form-group">
          <label htmlFor="phoneNumber">전화번호</label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="전화번호를 입력해 주세요"
            required
          />
        </div>
        {/* Publishing Type */}
        <div className="form-group">
          <label htmlFor="publication_type">출판유형</label>
          <select
            name="publicationType"
            value={formData.publicationType}
            onChange={handleChange}
            required
          >
            {publicationTypes.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="get-started-form-table"><PublishingComparison /></div>

        {/* <PublishingOptions
          selectedOption={formData.publicationType}
          onSelect={handleOptionSelect}
        /> */}

        {/* Details */}
        <div className="form-group details">
          {/* <label htmlFor="details">상담내용</label> */}
          <textarea
            id="details"
            name="details"
            rows="8"
            value={formData.details}
            onChange={handleChange}
            placeholder="출간을 희망하시는 원고의 주제, 현재 원고 상태, 상담받고 싶은 내용을 100자 이상 작성해 주세요. 홍보·마케팅 계획이 있다면 함께 적어주세요."
            required
          />
        </div>

        {/* File Upload */}
        <div className="form-group">
          <label>파일 첨부</label>
          <p className="file-description">
            원고 파일, 목차, 기획안, 샘플 원고 중 1개 이상을 첨부해 주세요.<br />
            ( 원고가 완성되지 않은 경우에도 목차나 기획안을 첨부해 주시면 검토가 가능합니다 )
          </p>
          <div className="manuscript-upload-section new-style">
            <div className="file-names-display">
              {files.length > 0 ? files.map((file, index) => (
                <div key={index} className="file-name">
                  <div className="remove-file-button" onClick={() => handleRemoveFile(index)}>
                    <img src="./images/close_icon_30.png" alt="remove" />
                  </div>
                  <span>{file.name}</span>
                </div>
              )) : "파일을 선택해 주세요(최대 5개)"}
            </div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
              accept=".pdf,.doc,.docx,.hwp,.txt"
              multiple              
            />
            <button type="button" className="upload-button" onClick={() => fileInputRef.current.click()} disabled={isSending}>
              파일 선택
            </button>
          </div>
        </div>

        {/* capcha code */}
        <div className="form-group">
          <label>보안문자</label>

          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <img
              src={captchaImg}
              alt="captcha"
              width={140}
              height={50}
              style={{ border: "1px solid #ddd", borderRadius: 6 }}
            />
            <button type="button" onClick={() => loadCaptcha()} disabled={isSending}>
              새로고침
            </button>
          </div>

          <input
            type="text"
            inputMode="numeric"
            value={captchaInput}
            onChange={(e) => setCaptchaInput(e.target.value.replace(/\D/g, "").slice(0, 5))}
            placeholder="이미지의 숫자를 입력해 주세요"
            autoComplete="off"
            required
          />
        </div>

        <LabelledCheckbox
          id="agreement"
          label={" 개인정보 수집 · 이용에 관한 동의(필수)"}
          checked={formData.agreement}
          onChange={handleChange}
        />


        <div className="form-group-button">
          <button
            type="button"
            onClick={!isSending ? handleEstimateClick : undefined}
            className="form-button"
            disabled={isSending}
          >
            모의 견적 산출하기
          </button>
          <button
            type="submit"
            className="form-button submit"
            disabled={!formData.agreement || isSending}
          >
            {isSending ? "전송 중..." : "보내기"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default GetStartedForm;
